document.addEventListener('DOMContentLoaded', function () {
    async function getCollection(page, sorting) {
        const loader = document.querySelector('.products-loader');
        if (loader) loader.style.display = 'block';

        let url = page;

        if (sorting) {
            url += (page.includes('?') ? '&' : '?') + 'sort_by=' + sorting;
        }

        try {
            const response = await fetch(url);
            const text = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');

            const newGrid = doc.querySelector('.collection-wrapper');
            const currentGrid = document.querySelector('.collection-wrapper');

            if (newGrid && currentGrid) {
                currentGrid.innerHTML = newGrid.innerHTML;
            }

            if (sorting) {
                const select = document.querySelector('select[name="sorting"]');
                if (select) select.value = sorting;
            }

        } catch (error) {
            console.error('Error fetching page:', error);
        } finally {
            if (loader) loader.style.display = 'none';
        }
    }

    document.addEventListener('click', function (e) {
        const link = e.target.closest('.pagination__list li a:not(.current-collection)');
        if (!link) return;

        e.preventDefault();

        document.querySelectorAll('.pagination__list li a').forEach(a => {
            a.classList.remove('current-collection');
        });

        link.classList.add('current-collection');

        const page = link.getAttribute('href');
        const sorting = document.querySelector('select[name="sorting"]')?.value;

        getCollection(page, sorting);
    });

    document.addEventListener('change', function (e) {
        const select = e.target.closest('select[name="sorting"]');
        if (!select) return;

        let page;

        const current = document.querySelector('.pagination__list li a.current-collection');

        if (current) {
            page = current.getAttribute('href');
        } else {
            page = window.location.href;
        }

        const sorting = select.value;

        getCollection(page, sorting);
    });
});